import { AsyncSubject } from 'rxjs'

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { FormControl } from '@angular/forms'

import { WallComponent } from '../../components/wall/wall.component'

import { AuthService } from '../auth.service'
import { LoginInterruptedByUserError } from '../errors'
import { User, BasicUser } from '../interfaces'

@Component({
  selector: 'app-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit {
  @ViewChild(WallComponent) wall: WallComponent

  @ViewChild('pinForm') userForm: ElementRef<HTMLFormElement>
  pin: FormControl = new FormControl('pin')

  auth: AuthService
  private authenticated: AsyncSubject<User | BasicUser | Error> = new AsyncSubject<User | BasicUser | Error>()

  loading = {
    pin: false
  }
  user: User | BasicUser

  constructor() { }

  ngOnInit() {
  }

  show () {
    this.wall.show()
  }

  hide () {
    this.wall.hide()
  }

  cancel () {
    this.hide()
    this.authenticated.error(new LoginInterruptedByUserError())
    this.authenticated.complete()
  }

  checkPin (user: User | BasicUser) {
    this.user = user
    setTimeout(() => this.show(), 200)
    return this.authenticated
      .finally(() => this.hide())
  }

  validate () {
    this.pin.disable()
    this.loading.pin = true
    this.auth.verifyPin(this.user.uid, this.pin.value)
    .subscribe(
      result => {
        this.authenticated.next(this.user)
        this.authenticated.complete()
        this.hide()
      },
      reason => {
        this.pin.setErrors({ api: reason.message })
        delete this.loading.pin
        this.pin.enable()
      },
    )
  }
}
